import { Component, OnDestroy, OnInit } from '@angular/core';
import { CustomerManagementService } from '../services/customer-management/customer-management.service';
import { CombinedUsage, Customer, FormattedUsage } from '../app.types';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { convertToUtcDate, convertTrialWindowToUtc } from 'src/util/date-helpers';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponentDialog } from '../confirm-dialog/confirm-dialog.component';
import { HttpResponseBase } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { UsageAmountsService } from '../services/usage/usage-amounts.service';

@Component({
    selector: 'customer-edit-page',
    templateUrl: './customer-edit-page.component.html',
    styleUrls: ['./customer-edit-page.component.scss'],
    standalone: false
})
export class CustomerEditPageComponent implements OnInit, OnDestroy {
  customerSubject = new Subject<Customer>();
  form: FormGroup;
  customer: Customer;
  usage: CombinedUsage = null;
  isLoadingCustomer = true;
  isConfiguringNotifications = false;

  constructor(private readonly customerManagementService: CustomerManagementService,
    private readonly usageAmountsService: UsageAmountsService,
    private readonly fb: FormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private readonly router: Router,
    private appRoot: AppComponent
  ) {
    this.form = fb.group({});
  }
  ngOnDestroy(): void {
    this.appRoot.clearUnsavedCheck();
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.pipe(
      switchMap((params: ParamMap) => 
        this.customerManagementService.getCustomer(params.get("id"))
    )).subscribe(res => {
      console.log(res);
      if(res.ok) {this.customerSubject.next(res.body);}
      this.isLoadingCustomer = false;
      this.customer = res.body;
    });

    this.appRoot.registerUnsavedCheck(() => !this.form.dirty);

    this.usageAmountsService.currentUsage.subscribe(x => this.usage = x);
  }

  canDeactivate(): boolean {
    return !this.form.dirty;
  }

  submitForm(): void {
      const { contractTerm: _, ...data} = this.form.getRawValue();
      data.id = this.customer.id;
      data.subscriptionDetailsId = this.customer.subscriptionDetailsId;
      data.createdDate = convertToUtcDate(data.createdDate);
      data.subscriptionStartDate = convertToUtcDate(data.subscriptionStartDate);
      data.subscriptionEndDate = convertToUtcDate(data.subscriptionEndDate);
      convertTrialWindowToUtc(data.subscriptionDetails);
      data.subdomain = "default";
      this.customerManagementService.editCustomer(data).subscribe(res => {
        if(res?.ok){
          this.form.markAsPristine();
          this.form.markAsUntouched();
        }
      });
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponentDialog, {
      data: {
        title: `Delete Tenancy`,
        message: `This action cannot be undone. All the details of this tenancy will be permanently removed.`,
        actions: [
          { text: "Cancel", result: false },
          { text: "Delete", result: true, color: "#D30A0A" }
        ]
      },
      autoFocus: false
    });
        
    dialogRef.afterClosed().subscribe((result) => {
      if (result == null) {return;}

      if (result == false) {console.log(`don't delete tenancy`);}

      if (result == true){
        this.customerManagementService.deleteCustomer(this.customer).subscribe(res => {
          if(res instanceof HttpResponseBase && res.ok){
            this.router.navigate(["../../"], {relativeTo: this.activatedRoute});
          }
        })
      }
    });
  }

  toggleNotificationsModal(){
    this.isConfiguringNotifications = !this.isConfiguringNotifications;
  }

  modalClosed(){
    this.isConfiguringNotifications = false;
  }
}
